import _ from 'lodash';
import trainerConfig from '../../config/trainer.json';

export function getInitParameters(game) {
    let games = _.cloneDeep(trainerConfig.games);
    let defaultParameters = game.parameters.default || game.parameters;
    if (game.slug === 'MultiplicationAndDivision') {
        let operations = _.cloneDeep(defaultParameters.operations);
        defaultParameters = _.find(
                games,
                { slug: 'MultiplicationAndDivision'}
        ).parameters.default;
        if (!operations.multiply) {
            defaultParameters.operations.divide = true;
            defaultParameters.operations.multiply = false;
        }
    } else if (game.slug === 'AdditionAndSubtraction') {
        let practiceRule = defaultParameters.practiceRule;
        defaultParameters = _.find(
                games,
                { slug: 'AdditionAndSubtraction'}
        ).parameters.default;
        defaultParameters.practiceRule = practiceRule;
    } else if (game.slug === 'AdditionAndSubtractionWithTime') {
        let voiceOver = defaultParameters.extraOptions.voiceOver;
        let practiceRule = defaultParameters.practiceRule;
        defaultParameters = _.find(
                games,
                { slug: 'AdditionAndSubtractionWithTime'}
        ).parameters.default;
        defaultParameters.extraOptions.voiceOver = voiceOver;
        defaultParameters.practiceRule = practiceRule;
    } else if (game.slug === 'AdditionAndSubtractionMathMagic') {
        defaultParameters = _.find(
                games,
                { slug: 'AdditionAndSubtractionMathMagic'}
        ).parameters.default;
    } else if (game.slug === 'InteractiveFlashCards') {
        defaultParameters = _.find(
                trainerConfig.games,
                { slug: 'InteractiveFlashCards'}
        ).parameters.default;
    } else if (game.slug === 'Equation') {
        defaultParameters = _.find(
                trainerConfig.games,
                { slug: 'Equation'}
        ).parameters.default;
    } else if (game.slug === 'Factorization') {
        defaultParameters = _.find(
            trainerConfig.games,
            { slug: 'Factorization'}
        ).parameters.default;
    } else if (game.slug === 'EquationMultiplication') {
        defaultParameters = _.find(
            trainerConfig.games,
            { slug: 'EquationMultiplication'}
        ).parameters.default;
    } else if (game.slug === 'Expressions') {
        defaultParameters = _.find(
            trainerConfig.games,
            { slug: 'Expressions' }
        ).parameters.default;
    } else if (game.slug === 'Anzan') {
        defaultParameters = _.find(
            trainerConfig.games,
            { slug: 'Anzan' }
        ).parameters.default;
    } else if (game.slug === 'Puzzle') {
        defaultParameters = _.find(
            trainerConfig.games,
            { slug: 'Puzzle' }
        ).parameters.default;
    } else if (game.slug === 'Chains') {
        defaultParameters = _.find(
            trainerConfig.games,
            { slug: 'Chains' }
        ).parameters.default;
    } else if (game.slug === 'Couples') {
        defaultParameters = _.find(
            trainerConfig.games,
            { slug: 'Couples' }
        ).parameters.default;
    } else if (game.slug === 'Schulte') {
        defaultParameters = _.find(
            trainerConfig.games,
            { slug: 'Schulte' }
        ).parameters.default;
    } else if (game.slug === 'VisionField') {
        defaultParameters = _.find(
            trainerConfig.games,
            { slug: 'VisionField' }
        ).parameters.default;
    } else if (game.slug === 'Texts') {
        defaultParameters = _.find(
            trainerConfig.games,
            { slug: 'Texts' }
        ).parameters.default;
    } else if (game.slug === 'TextsOnline') {
        defaultParameters = _.find(
            trainerConfig.games,
            { slug: 'TextsOnline' }
        ).parameters.default;
    } else if (game.slug === 'Classifications') {
        defaultParameters = _.find(
            trainerConfig.games,
            { slug: 'Classifications' }
        ).parameters.default;
    } else if (game.slug === 'Navigator') {
        defaultParameters = _.find(
            trainerConfig.games,
            { slug: 'Navigator' }
        ).parameters.default;
    } else if (game.slug === 'Matrix') {
        defaultParameters = _.find(
            trainerConfig.games,
            { slug: 'Matrix' }
        ).parameters.default;
    } else if (game.slug === 'Memorize') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'Memorize' }).parameters.default;
    } else if (game.slug === 'KeenEye') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'KeenEye' }).parameters.default;
    } else if (game.slug === 'KeenEyeBonusGames') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'KeenEyeBonusGames' }).parameters.default;
    } else if (game.slug === 'NumericalNetwork') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'NumericalNetwork' }).parameters.default;
    } else if (game.slug === 'RootsAndDegrees') {
        defaultParameters = _.find(
            trainerConfig.games,
            { slug: 'RootsAndDegrees' }
        ).parameters.default;
    } else if (game.slug === 'MultiplicationAndDivisionMathMagic') {
        defaultParameters = _.find(
            trainerConfig.games,
            { slug: 'MultiplicationAndDivisionMathMagic' }
        ).parameters.default;
    } else if (game.slug === 'AssembleTheNumber') {
        defaultParameters = _.find(
            trainerConfig.games,
            { slug: 'AssembleTheNumber' }
        ).parameters.default;
    } else if (game.slug === 'RootsAndSquares') {
        defaultParameters = _.find(
            trainerConfig.games,
            { slug: 'RootsAndSquares' }
        ).parameters.default;
    } else if (game.slug === 'Loner') {
        defaultParameters = _.find(
            trainerConfig.games,
            {slug: 'Loner'}
        ).parameters.default;
    } else if (game.slug === 'SequenceOfNumbers') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'SequenceOfNumbers' }).parameters.default;
    } else if (game.slug === 'CouplesMemoryDevelopment') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'CouplesMemoryDevelopment' }).parameters.default;
    } else if (game.slug === 'RevivedNumbers') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'RevivedNumbers' }).parameters.default;
    } else if (game.slug === 'Associations') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'Associations' }).parameters.default;
    } else if (game.slug === 'WhoIsWho') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'WhoIsWho' }).parameters.default;
    } else if (game.slug === 'CosmoTour') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'CosmoTour' }).parameters.default;
    } else if (game.slug === 'SecretsOfCicero') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'SecretsOfCicero' }).parameters.default;
    } else if (game.slug === 'VocabularyWords') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'VocabularyWords' }).parameters.default;
    } else if (game.slug === 'VocabularyMemo') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'VocabularyMemo' }).parameters.default;
    } else if (game.slug === 'CorrectiveSamples') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'CorrectiveSamples' }).parameters.default;
    } else if (game.slug === 'MemoBonusGames') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'MemoBonusGames' }).parameters.default;
    } else if (game.slug === 'NavigatorBonusGames') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'NavigatorBonusGames' }).parameters.default;
    } else if (game.slug === 'ChainsBonusGame') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'ChainsBonusGame' }).parameters.default;
    } else if (game.slug === 'Scout') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'Scout' }).parameters.default;
    } else if (game.slug === 'Diada') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'Diada' }).parameters.default;
    } else if (game.slug === 'SynonymsReadingEn') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'SynonymsReadingEn' }).parameters.default;
    } else if (game.slug === 'TransferSyllables') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'TransferSyllables' }).parameters.default;
    } else if (game.slug === 'DivideItRight') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'DivideItRight' }).parameters.default;
    } else if (game.slug === 'LettersSoundsSyllables') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'LettersSoundsSyllables' }).parameters.default;
    } else if (game.slug === 'PunctuationMarks') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'PunctuationMarks' }).parameters.default;
    } else if (game.slug === 'HardSoftConsonants') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'HardSoftConsonants' }).parameters.default;
    } else if (game.slug === 'TranscriptionInWord') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'TranscriptionInWord' }).parameters.default;
    } else if (game.slug === 'VoicedAndDeafConsonants') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'VoicedAndDeafConsonants' }).parameters.default;
    } else if (game.slug === 'Alphabet') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'Alphabet' }).parameters.default;
    } else if (game.slug === 'ConnectThePuzzles') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'ConnectThePuzzles' }).parameters.default;
    } else if (game.slug === 'Orthograph') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'Orthograph' }).parameters.default;
    } else if (game.slug === 'ChooseItRight') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'ChooseItRight' }).parameters.default;
    } else if (game.slug === 'DivideUnstressedVowels') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'DivideUnstressedVowels' }).parameters.default;
    }  else if (game.slug === 'VocabularyWordsRus') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'VocabularyWordsRus' }).parameters.default;
    }  else if (game.slug === 'WordDrum') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'WordDrum' }).parameters.default;
    }  else if (game.slug === 'VocabularyMemoRus') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'VocabularyMemoRus' }).parameters.default;
    } else if (game.slug === 'PartsOfSpeech') {
        defaultParameters = _.find(trainerConfig.games, {slug: 'PartsOfSpeech'}).parameters.default;
    } else if (game.slug === 'ParsingSentencePartsSpeech') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'ParsingSentencePartsSpeech' }).parameters.default;
    } else if (game.slug === 'SortOneMany') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'SortOneMany' }).parameters.default;
    } else if (game.slug === 'GenericWords') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'GenericWords' }).parameters.default;
    } else if (game.slug === 'VerbTenses') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'VerbTenses' }).parameters.default;
    } else if (game.slug === 'WordStructure') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'WordStructure' }).parameters.default;
    } else if (game.slug === 'SentenceParsing') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'SentenceParsing' }).parameters.default;
    } else if (game.slug === 'SynonymsRussianLanguage') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'SynonymsRussianLanguage' }).parameters.default;
    } else if (game.slug === 'AntonymsRussianLanguage') {
        defaultParameters = _.find(trainerConfig.games, { slug: 'AntonymsRussianLanguage' }).parameters.default;
    }
    return defaultParameters;
}
